import Album from '../components/Album';
import Breadcrumb from '../components/Breadcrumb';
import TitlePage from '../components/TitlePage';
import masterclasses from '../mocks/masterclasses.json';

const Training = () => {
    return (
        <>
            <Breadcrumb history={[{ title: 'Home', to: '/' }]} current='Formazione' />

            <section id='careercoach' className='services'>
                <TitlePage title='Formazione' />

                <div className='container'>
                    <div className='row gy-4'>
                        <div className='col-12 d-flex' data-aos='fade-up' data-aos-delay='100'>
                            <div className='row service-item'>
                                <div className='col-md-6 text-center'>
                                    <img src={'img/album/careercoach.webp'} className='img-fluid img-cover' alt='' />
                                </div>
                                <div className='col-md-6 mt-3 mt-md-0'>
                                    <p>
                                        Sei uno/a studente/ssa di moda alle prime armi? Non sai come orientarti nel mare di offerte
                                        lavorative? O semplicemente non sai ancora quale sia la tua strada?
                                        <br />
                                        Glami ti offre un servizio di coaching studiato per seguirti e supportarti nella scelta del tuo
                                        percorso formativo o nella professione dei tuoi sogni.
                                    </p>
                                    <ul className='mt-3'>
                                        <li>
                                            <i className='bi bi-check2-circle'></i> <span>Percorsi personalizzati One-to-one;</span>
                                        </li>
                                        <li>
                                            <i className='bi bi-check2-circle'></i>
                                            <span>Creazione del curriculum e/o portfolio professionale;</span>
                                        </li>
                                        <li>
                                            <i className='bi bi-check2-circle'></i>
                                            <span>Studio delle skills e del profilo professionale;</span>
                                        </li>
                                        <li>
                                            <i className='bi bi-check2-circle'></i>
                                            <span>Creazione della lettera motivazionale e preparazione ai colloqui.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id='masterclass' className='services dark'>
                <div className='container section-title-dark' data-aos='fade-up'>
                    <h2>MASTERCLASS</h2>
                </div>

                <div className='container'>
                    <div className='row gy-4'>
                        <div className='col-12 d-flex' data-aos='fade-up' data-aos-delay='100'>
                            <div className='service-item-dark position-relative'>
                                <div className='icon-label'>
                                    <i className='bi bi-airplane-fill'></i> <span>MILANO INSIDE FASHION</span>
                                </div>
                                <ul>
                                    <li>
                                        <i className='bi bi-check2-circle'></i>
                                        <span>
                                            <strong>Styling and Editorial</strong>: Parteciperai ad un vero editoriale commerciale durante
                                            il quale avrai la possibilità di interfacciarsi con i professionisti del settore e comprendere
                                            le figure dello stylist, fotograf*, modell*, Make-up artist e Hair-styilist. Ti metterai in
                                            gioco in maniera attiva nell’attività di fashion editor e potrai ampliare o costruire la tua
                                            rete di contatti.
                                        </span>
                                    </li>
                                    <li>
                                        <i className='bi bi-check2-circle'></i>
                                        <span>
                                            <strong>Formazione</strong>: Una o più giornate dedicate ai nostri workshop, tenuti da
                                            professionisti dei settori - Branding, Comunicazione e Marketing - Design, Styling e Prodotto -
                                            Risorse umane e pubbliche relazioni - Organizzazione eventi - Artigianato, manifattura e
                                            vintage.
                                        </span>
                                    </li>
                                    <li>
                                        <i className='bi bi-check2-circle'></i>
                                        <span>
                                            <strong>Backstage</strong>: le giornate “Full Day” all’interno dei backstage ti permetteranno di
                                            conoscere le dinamiche di progettazione e organizzazione di un evento di moda.
                                            <br />
                                            Entrerai in contatto con figure quali:
                                            <ul>
                                                <li>
                                                    <i className='bi bi-check2'></i>
                                                    <span>
                                                        Direzione - Art Director, Event Planner, Project Manager, Staff Coordinator;
                                                    </span>
                                                </li>
                                                <li>
                                                    <i className='bi bi-check2'></i> <span>Fashion designer;</span>
                                                </li>
                                                <li>
                                                    <i className='bi bi-check2'></i> <span>PR - Press e Fotografi;</span>
                                                </li>
                                                <li>
                                                    <i className='bi bi-check2'></i>
                                                    <span>Beauty Team - Models, Hair-Stylist, Make-up Artist.</span>
                                                </li>
                                            </ul>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className='col-12 d-flex' data-aos='fade-up' data-aos-delay='100'>
                            <div className='service-item-dark position-relative'>
                                <div className='icon-label'>
                                    <i className='bi bi-airplane-fill'></i> <span>PARIGI INSIDE FASHION</span>
                                </div>
                                <ul>
                                    <li>
                                        <i className='bi bi-check2-circle'></i>
                                        <span>
                                            <strong>Visita guidata della città</strong>: Visiteremo i luoghi della città legati al mondo
                                            della moda, partecipando a mostre nei musei più importanti, faremo un tour dello shopping e ci
                                            ritaglieremo del tempo per visitare i luoghi più iconici.
                                        </span>
                                    </li>
                                    <li>
                                        <i className='bi bi-check2-circle'></i>
                                        <span>
                                            <strong>Backstage</strong>: le giornate “Full Day” all’interno dei backstage ti permetteranno di
                                            conoscere le dinamiche di progettazione e organizzazione di un evento di moda.
                                            <br />
                                            Entrerai in contatto con figure quali:
                                            <ul>
                                                <li>
                                                    <i className='bi bi-check2'></i>
                                                    <span>
                                                        Direzione – Art Director, Event Planner, Project Manager, Staff Coordinator;
                                                    </span>
                                                </li>
                                                <li>
                                                    <i className='bi bi-check2'></i> <span>Fashion designer;</span>
                                                </li>
                                                <li>
                                                    <i className='bi bi-check2'></i> <span>PR – Press e Fotografi;</span>
                                                </li>
                                                <li>
                                                    <i className='bi bi-check2'></i>
                                                    <span>Beauty Team – Models, Hair-Stylist, Make-up Artist.</span>
                                                </li>
                                            </ul>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className='col-12 d-flex' data-aos='fade-up' data-aos-delay='100'>
                            <div className='service-item-dark position-relative'>
                                <div className='icon-label'>
                                    <i className='bi bi-airplane-fill'></i> <span>ROMA INSIDE FASHION</span>
                                </div>
                                <ul>
                                    <li>
                                        <i className='bi bi-check2-circle'></i>
                                        <span>
                                            <strong>Styling and Editorial</strong>: Parteciperai ad un vero editoriale commerciale durante
                                            il quale avrai la possibilità di interfacciarsi con i professionisti del settore e comprendere
                                            le figure dello stylist, fotograf*, modell*, Make-up artist e Hair-styilist. Ti metterai in
                                            gioco in maniera attiva nell’attività di fashion editor e potrai ampliare o costruire la tua
                                            rete di contatti.
                                        </span>
                                    </li>
                                    <li>
                                        <i className='bi bi-check2-circle'></i>
                                        <span>
                                            <strong>Formazione</strong>: Una o più giornate dedicate ai nostri workshop, tenuti da
                                            professionisti dei settori - Branding, Comunicazione e Marketing - Design, Styling e Prodotto -
                                            Risorse umane e pubbliche relazioni - Organizzazione eventi - Artigianato, manifattura e
                                            vintage.
                                        </span>
                                    </li>
                                    <li>
                                        <i className='bi bi-check2-circle'></i>
                                        <span>
                                            <strong>Backstage</strong>: le giornate “Full Day” all’interno dei backstage ti permetteranno di
                                            conoscere le dinamiche di progettazione e organizzazione di un evento di moda.
                                            <br />
                                            Entrerai in contatto con figure quali:
                                            <ul>
                                                <li>
                                                    <i className='bi bi-check2'></i>
                                                    <span>
                                                        Direzione - Art Director, Event Planner, Project Manager, Staff Coordinator;
                                                    </span>
                                                </li>
                                                <li>
                                                    <i className='bi bi-check2'></i> <span>Fashion designer;</span>
                                                </li>
                                                <li>
                                                    <i className='bi bi-check2'></i> <span>PR - Press e Fotografi;</span>
                                                </li>
                                                <li>
                                                    <i className='bi bi-check2'></i>
                                                    <span>Beauty Team - Models, Hair-Stylist, Make-up Artist.</span>
                                                </li>
                                            </ul>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className='col-12 d-flex' data-aos='fade-up' data-aos-delay='100'>
                            <div className='service-item-dark position-relative'>
                                <div className='icon-label'>
                                    <i className='bi bi-airplane-fill'></i> <span>BOLOGNA INSIDE FASHION</span>
                                </div>
                                <ul>
                                    <li>
                                        <i className='bi bi-check2-circle'></i>
                                        <span>
                                            <strong>Styling and Editorial</strong>: Parteciperai ad un vero editoriale commerciale durante
                                            il quale avrai la possibilità di interfacciarsi con i professionisti del settore e comprendere
                                            le figure dello stylist, fotograf*, modell*, Make-up artist e Hair-styilist. Ti metterai in
                                            gioco in maniera attiva nell’attività di fashion editor e potrai ampliare o costruire la tua
                                            rete di contatti.
                                        </span>
                                    </li>
                                    <li>
                                        <i className='bi bi-check2-circle'></i>
                                        <span>
                                            <strong>Formazione</strong>: Una o più giornate dedicate ai nostri workshop, tenuti da
                                            professionisti dei settori - Branding, Comunicazione e Marketing - Design, Styling e Prodotto -
                                            Risorse umane e pubbliche relazioni - Organizzazione eventi - Artigianato, manifattura e
                                            vintage.
                                        </span>
                                    </li>
                                    <li>
                                        <i className='bi bi-check2-circle'></i>
                                        <span>
                                            <strong>Backstage</strong>: le giornate “Full Day” all’interno dei backstage ti permetteranno di
                                            conoscere le dinamiche di progettazione e organizzazione di un evento di moda.
                                            <br />
                                            Entrerai in contatto con figure quali:
                                            <ul>
                                                <li>
                                                    <i className='bi bi-check2'></i>
                                                    <span>
                                                        Direzione - Art Director, Event Planner, Project Manager, Staff Coordinator;
                                                    </span>
                                                </li>
                                                <li>
                                                    <i className='bi bi-check2'></i> <span>Fashion designer;</span>
                                                </li>
                                                <li>
                                                    <i className='bi bi-check2'></i> <span>PR - Press e Fotografi;</span>
                                                </li>
                                                <li>
                                                    <i className='bi bi-check2'></i>
                                                    <span>Beauty Team - Models, Hair-Stylist, Make-up Artist.</span>
                                                </li>
                                            </ul>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='album'>
                <div className='container section-title' data-aos='fade-up'>
                    <h2>Album</h2>
                </div>

                <div className='container'>
                    <div className='row gy-4' data-aos='fade-up' data-aos-delay='100'>
                        {masterclasses.map(item => (
                            <Album title={item.title} to={`gallery/${item.id}`} path={item.path} alt={item.alt} />
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};
export default Training;
